import { render, staticRenderFns } from "./StepSection.vue?vue&type=template&id=870198e0&"
import script from "./StepSection.vue?vue&type=script&lang=js&"
export * from "./StepSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports